import apiClient from '~/config/apiClient';
import { PaginationResult } from '~/libs/types/pagination.types';

import {
  FindAllReportPhotosResult,
  FindAllReportTimelapsesResult,
  FindAllReportsParams,
  FindAllReportsResult,
  ReportListPhotoModel,
  ReportModel,
} from './types';

export const findAllReports = (params: FindAllReportsParams) => {
  return apiClient.get<FindAllReportsResult>('/reports', { params });
};

export const findAllReportPhotos = (params: FindAllReportsParams) => {
  return apiClient.get<FindAllReportPhotosResult>('/reports/photo', { params });
};

export const findAllReportTimelapses = (params: FindAllReportsParams) => {
  return apiClient.get<FindAllReportTimelapsesResult>('/reports/timelapse', { params });
};

export const findOneReportPhoto = (reportId: string, fileId: string, project_id: string) => {
  return apiClient.get<ReportListPhotoModel>(`/reports/${reportId}/file/${fileId}`, {
    params: {
      project_id,
    },
  });
};

export interface DraftReportModel {
  accessLevel: string;
  isDraft: boolean;
  workDate: string;
  _id: string;
}

export const findAllDraftReports = (params: { project_id: string }) => {
  return apiClient.get<PaginationResult<DraftReportModel>>('/reports/draft', { params });
};

export const findOneReport = (projcetId: string, reportId: string) =>
  apiClient.get<ReportModel>(`/reports/${reportId}`, { params: { project_id: projcetId } });
